import { render, staticRenderFns } from "./MutiplayerIcon.vue?vue&type=template&id=76936a93&"
import script from "./MutiplayerIcon.vue?vue&type=script&lang=js&"
export * from "./MutiplayerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports